export const geoCtaTemplate = (garage) => {
    return `
        ${garage.address},
        ${garage.city}
    `
}

export const geoModalPhoneTemplate = (garage) => {
    return `
        <strong><a href="tel:${garage.phone_compact}">${garage.phone}</a></strong>
    `
}

export const geoModalAddressTemplate = (garage) => {
    return `
        ${garage.address}<br>
        ${garage.city}, ${garage.province}<br>
        ${garage.postalcode}
    `
}


// WEBPACK FOOTER //
// ./scripts/templates/geo.js